export const APP_THEME = {
  light: "light",
  dark: "dark",
} as const

export type AppTheme = (typeof APP_THEME)[keyof typeof APP_THEME]

const STORAGE_KEY = "nova-theme"
const THEME_COLOR = {
  [APP_THEME.light]: "#f5f5f2",
  [APP_THEME.dark]: "#1c1c1b",
} satisfies Record<AppTheme, string>

export function initializeTheme(): AppTheme {
  const stored = readStoredTheme()
  const theme = stored ?? systemTheme()
  applyTheme(theme)
  return theme
}

export function currentTheme(): AppTheme {
  return document.documentElement.classList.contains(APP_THEME.dark)
    ? APP_THEME.dark
    : APP_THEME.light
}

export function setTheme(theme: AppTheme): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, theme)
  } catch {
    // Storage can be disabled by the browser. The in-memory theme still works.
  }
  applyTheme(theme)
}

function applyTheme(theme: AppTheme): void {
  document.documentElement.classList.toggle(APP_THEME.dark, theme === APP_THEME.dark)
  document.documentElement.style.colorScheme = theme
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", THEME_COLOR[theme])
}

function readStoredTheme(): AppTheme | null {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    return stored === APP_THEME.light || stored === APP_THEME.dark ? stored : null
  } catch {
    return null
  }
}

function systemTheme(): AppTheme {
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? APP_THEME.dark
    : APP_THEME.light
}
